import { Skeleton, Stack } from "@mui/material";
import { type FC } from "react";

import { EventMetricsSkeleton } from "~/feature/event/components/EventMetrics/EventMetricsSkeleton";

import * as Styled from "./EventHeader.styles";

const EVENT_ICON_SIZE = 64;
const ACTION_BUTTON_SIZE = 32;
const TAG_HEIGHT = 24;
const TITLE_HEIGHT = 32;

export const EventHeaderSkeleton: FC = () => {
  return (
    <Styled.Root>
      <Skeleton
        variant="circular"
        width={EVENT_ICON_SIZE}
        height={EVENT_ICON_SIZE}
        sx={{ flexShrink: 0 }}
      />

      <Styled.ContentBox>
        <Styled.InnerStack>
          <Styled.TitleStack>
            <Styled.TitleRow>
              <Stack direction="row" sx={{
                gap: 1
              }}>
                <Skeleton variant="rounded" width={72} height={TAG_HEIGHT} />
                <Skeleton variant="rounded" width={96} height={TAG_HEIGHT} />
              </Stack>

              <Stack direction="row" sx={{
                gap: 1
              }}>
                <Skeleton
                  variant="circular"
                  width={ACTION_BUTTON_SIZE}
                  height={ACTION_BUTTON_SIZE}
                />
                <Skeleton
                  variant="circular"
                  width={ACTION_BUTTON_SIZE}
                  height={ACTION_BUTTON_SIZE}
                />
              </Stack>
            </Styled.TitleRow>

            <Skeleton variant="text" width="100%" height={TITLE_HEIGHT} />
            <Skeleton
              variant="text"
              height={TITLE_HEIGHT}
              sx={{ width: { xs: "70%", md: "45%" } }}
            />

            <Skeleton variant="text" width={220} height={20} />
          </Styled.TitleStack>

          <EventMetricsSkeleton />
        </Styled.InnerStack>
      </Styled.ContentBox>
    </Styled.Root>
  );
};
